// helpers/firstAllowedRoute.js
import { FEATURE as F } from "../constants/permisos";

export const FIRST_ROUTES_ORDER = [
  { path: "/dashboard/admin", bit: F.INICIO_VIEW },
  { path: "/usuarios-temporales", bit: F.USUARIOS_TEMP_VIEW },
  { path: "/estanques", bit: F.ESTANQUES_VIEW },
  { path: "/dispositivos", bit: F.DISPOSITIVOS_VIEW },
  { path: "/sensores", bit: F.SENSORES_VIEW },
  { path: "/efectores", bit: F.EFECTORES_VIEW },
  { path: "/automatizacion", bit: F.AUTOMATIZACION_VIEW },
  { path: "/alarmas", bit: F.ALARMAS_VIEW },
  { path: "/reporteria", bit: F.REPORTERIA_VIEW },
  { path: "/configuraciones", bit: F.CONFIGURACIONES_VIEW },
];

export function computeFirstAllowedRoute(bitset, hasBit) {
  for (const r of FIRST_ROUTES_ORDER) {
    if (hasBit(bitset, r.bit)) return r.path;
  }
  return "/"; // fallback
}
